import React from 'react';
import { Alert, Form, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import loginbg from "../../images/login-bg-4.jpg";


const ForgotPassword = () => {
  

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const emailValidation = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Adresse e-mail invalide').required('L\'e-mail est requis')
    }),
    onSubmit: (values) => {
      // dispatch(verifyEmail(values, navigate));
    }
  });

  const selectState = (state) => state;
  const emailData = createSelector(
    selectState,
    (state) => ({
      error: state.Account.error,
      errorMsg: state.Account.errorMsg,
    })
  );

  const { error } = useSelector(emailData);

  return (
    <div className="login-main-page" style={{backgroundImage:"url("+ loginbg +")", height: "100vh", width: "100vw"}}>
    <div className="auth-form-wrapper d-flex justify-content-center align-items-center min-vh-200">
      <div className="auth-form p-4 rounded shadow-sm bg-white" style={{ maxWidth: "900px", width: "90%" }}>
        {error && (
            <Alert variant="danger" className="animate__animated animate__fadeIn">
              {error}
            </Alert>
          )}
          <h2 className="text-center mb-4 text-primary fw-bold">Vérifier votre adresse e-mail</h2>
          <Form onSubmit={emailValidation.handleSubmit}>
            <Form.Group className="mb-4">
              <Form.Control
                type="email"
                name="email"
                value={emailValidation.values.email}
                onChange={emailValidation.handleChange}
                isInvalid={emailValidation.touched.email && emailValidation.errors.email}
                placeholder="Entrez votre email"
                className="form-control py-2 border-primary-subtle"
              />
              <Form.Control.Feedback type="invalid">
                {emailValidation.errors.email}
              </Form.Control.Feedback>
            </Form.Group>
            <div className="d-grid gap-2 mt-4">
              <Button 
                variant="primary" 
                type="submit" 
                className="btn-lg btn-primary py-2 fw-semibold shadow-sm hover-effect"
              >
                Soumettre
              </Button>
            </div>
            <div className="text-center mt-4">
              <Link 
                to="/login" 
                className="text-decoration-none fw-medium"
              >
                ← Retour à la connexion
              </Link>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
